import { createContext } from 'react'
import type { Context } from 'react'
import type { SupplyOrderStateType } from 'storeContext/reducers/supplyOrder'
import type { DispatchFnType } from 'storeContext/types'

export type SupplyOrderDispatchType = (
  action:
    | { type: string; payload?: unknown }
    | ((dispatch: DispatchFnType) => void | Promise<void>),
) => void
export type SupplyOrderContextValueType = {
  state: SupplyOrderStateType
  dispatch: SupplyOrderDispatchType
}

// Retain the raw-state default used by the existing JS context barrel.
export const createSupplyOrderContext = (initialState: SupplyOrderStateType) =>
  createContext(initialState) as unknown as Context<SupplyOrderContextValueType>
